import React, { useMemo } from 'react';
import './Footer.css'
import { Link as Anchor } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser } from '@fortawesome/free-solid-svg-icons';
import { useData } from '../DataContext';
import { useLogo } from '../LogoContext';
import VERSION from '../version';
import { ruta } from '../paths';
export default function Footer() {
    const { productos: allProductos, contacto } = useData();
    const { logo } = useLogo();

    const contactos = useMemo(() => {
        if (Array.isArray(contacto)) {
            return [...contacto].reverse()[0] || {};
        }
        return contacto || {};
    }, [contacto]);

    const productos = useMemo(() => (allProductos || []).slice(0, 3), [allProductos]);


    return (
        <div className='FooterContain'>
            <div className='footerText'>
                <Anchor to='' target="_blank">   <img src={logo} alt="logo" /></Anchor>
                <h2>
                    {contactos.nombre}
                </h2>
                <div className='socials'>
                    <Anchor to={contactos.instagram} target="_blank"><i className='fa fa-instagram'></i></Anchor>
                    <Anchor to={`tel:${contactos.telefono}`} target="_blank"><i className='fa fa-whatsapp'></i></Anchor>
                    <Anchor to={contactos.facebook} target="_blank"><i className='fa fa-facebook'></i></Anchor>

                </div>
            </div>
            <div className='footerText'>
                <h3>Contacto</h3>
                <Anchor to={`mailto:${contactos.email}`} target="_blank">{contactos.email}</Anchor>
                <Anchor to={`tel:${contactos.telefono}`} target="_blank">{contactos.telefono}</Anchor>
                <Anchor to={`https://www.google.com/maps?q=${encodeURIComponent(contactos.direccion)}`} target="_blank">{contactos.direccion}</Anchor>

            </div>
            <div className='footerText'>
                <h3>Productos</h3>
                {
                    productos?.map(item => (
                        <Anchor to='' key={item.idProducto}>{item?.titulo?.slice(0, 33)}</Anchor>
                    ))
                }

            </div>
            <div className='footerText'>
                <h3>Acceso</h3>
                <Anchor to={ruta('/dashboard')} className='btnAnch'>
                    <FontAwesomeIcon icon={faUser} /> Dashboard
                </Anchor>
            </div>
            <div className='footerVersion'>Versión {VERSION}</div>
        </div>
    )
}
